// FadeInWhenVisible.js
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { cloneElement, useEffect, Children } from "react";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const FadeInWhenVisible = ({ category, className, children }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: false, threshold: 0.2 });
  const sidebarModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.sidebarModal;
  });

  useEffect(() => {
    if (inView && sidebarModal) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView, sidebarModal]);

  const containerVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.2,
        when: "beforeChildren",
        staggerChildren: 0.1, // Controls line-wise animation timing
      },
    },
  };
  const childVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.3 },
    },
  };
  return (
    <motion.li
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={containerVariants}
      style={{ overflow: "hidden" }}
      data-category={category}
      className={className}
    >
      {Children.map(children, (child, i) =>
        cloneElement(
          <motion.div key={i} variants={childVariants}>
            {child}
          </motion.div>,
          { key: i }
        )
      )}
    </motion.li>
  );
};

export default FadeInWhenVisible;
